import { createFileRoute } from '@tanstack/react-router';
import { Loading } from '../components/layout/Loading.js';

export const Route = createFileRoute('/auth/handoff')({ component: Handoff });

/**
 * The handoff landing.
 *
 * The API route of the same name is what actually sets the cookie and redirects, so reaching
 * this component means the browser is mid-redirect. It only ever shows a spinner.
 */
function Handoff() {
  return <Loading label="Opening your browser" />;
}
